<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="center50" id="_idParaDest-1">
<img alt="" src="image/Spooky_Page19A.png"/>
</div>
<p class="frontmatter_dedication"> </p>
<p class="frontmatter_dedication">Dedication</p>
<p class="frontmatter_dedication">To Rafi, Henrik, Greta, and Fredrik </p>
<p class="frontmatter_dedication"> </p>
<p class="frontmatter_dedication">To the courthouse dogs</p>
<p class="frontmatter_dedication">Thank you for good work you do</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HelperHounds_Bk6_Spooky.vue?17a14a9a